var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ expanded: _vm.expanded },attrs:{"aria-controls":_vm.disclosureId,"aria-expanded":_vm.expanded.toString()},on:{"click":_vm.maybeExpanded}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }